// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"SectionTitle_sectionTitle__iB30t","icon":"SectionTitle_icon__ccopp","title":"SectionTitle_title__wH0Iy"};